<div class="users-container">
    <button class="button" (click)="openUserDialog()">New user</button>
    <div class="users-table">
        <div class="users-table-header">
            <div class="id">ID</div>
            <div class="name">Username</div>
            <div class="name">Name</div>
            <div class="surname">Surname</div>
            <div class="admin">Admin</div>
        </div>
        <div class="user" *ngFor="let user of users" (click)="openUserDialog(user)">
            <div class="id">{{user.id}}</div>
            <div class="name">{{user.userName}}</div>
            <div class="name">{{user.name}}</div>
            <div class="surname">{{user.surname}}</div>
            <div class="admin">{{user.admin?'Yes':'No'}}</div>
        </div>
    </div>
</div>